import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import axios from "axios";
import fetcher from "@/common/axiosInstance";
export function api__uploadAttachments(_x, _x2, _x3, _x4, _x5, _x6) {
  return _api__uploadAttachments.apply(this, arguments);
}
function _api__uploadAttachments() {
  _api__uploadAttachments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(fileObjects, preSignData, uploadDocumentsData, orderId, stepNum, isFinance) {
    var toUploadDocuments, resignedUrls;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          Object.keys(preSignData).forEach(function (key) {
            var _preSignData$key;
            var fileObject = (_preSignData$key = preSignData[key]) !== null && _preSignData$key !== void 0 ? _preSignData$key : {};
            var fileObjectPath = fileObject.path;
            if (!fileObjectPath) return;
            var fltr = function fltr(u) {
              return u.path === fileObjectPath;
            };
            if (uploadDocumentsData.filter(fltr).length === 0) {
              console.log('api__uploadAttachments__delete/preSignData', key, preSignData[key]);
              delete preSignData[key];
            }
          });
          toUploadDocuments = [];
          Object.values(preSignData || []).forEach(function (preSignItem) {
            var foundItem = uploadDocumentsData.find(function (uploadItem) {
              return uploadItem.path === preSignItem.path;
            });
            if (foundItem) {
              toUploadDocuments.push(foundItem);
            }
          });
          _context.n = 1;
          return preSignUrl(preSignData, isFinance);
        case 1:
          resignedUrls = _context.v;
          return _context.a(2, uploadFiles(fileObjects, resignedUrls).then(function () {
            uploadDocuments(toUploadDocuments, orderId, stepNum, isFinance);
          }));
      }
    }, _callee);
  }));
  return _api__uploadAttachments.apply(this, arguments);
}
function uploadFiles(_x7, _x8) {
  return _uploadFiles.apply(this, arguments);
}
function _uploadFiles() {
  _uploadFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(fileObjects, presignedUrls) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, Promise.all(Object.keys(fileObjects).map(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(key) {
              var fileObject, presignedUrl, response;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    fileObject = fileObjects[key];
                    presignedUrl = presignedUrls[key];
                    _context2.n = 1;
                    return axios.put(presignedUrl, fileObject, {
                      headers: {
                        "Content-Type": fileObject.type
                      }
                    });
                  case 1:
                    response = _context2.v;
                    if (!(response.status !== 200)) {
                      _context2.n = 2;
                      break;
                    }
                    throw new Error("File upload failed");
                  case 2:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x13) {
              return _ref.apply(this, arguments);
            };
          }())));
      }
    }, _callee3);
  }));
  return _uploadFiles.apply(this, arguments);
}
function uploadDocuments(_x9, _x0, _x1, _x10) {
  return _uploadDocuments.apply(this, arguments);
}
function _uploadDocuments() {
  _uploadDocuments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(documents, orderId, stepNum, isFinance) {
    var apiUrl, data, res;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          apiUrl = isFinance ? "/finance-tracking/upload-document" : "/order-tracking/upload-document";
          data = {
            order_id: orderId,
            documents: documents,
            step: stepNum
          };
          _context4.n = 1;
          return fetcher(null, true).post(apiUrl, data);
        case 1:
          res = _context4.v;
          if (!(res.data.code !== 200)) {
            _context4.n = 2;
            break;
          }
          throw new Error("Failed to upload documents");
        case 2:
          return _context4.a(2, res.data);
      }
    }, _callee4);
  }));
  return _uploadDocuments.apply(this, arguments);
}
function preSignUrl(_x11, _x12) {
  return _preSignUrl.apply(this, arguments);
}
function _preSignUrl() {
  _preSignUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(documents, isFinance) {
    var apiUrl, res;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          apiUrl = isFinance ? "/finance-tracking/get-presigned-url" : "/order-tracking/get-presigned-url";
          _context5.n = 1;
          return fetcher(null, true).post(apiUrl, {
            documents: documents
          });
        case 1:
          res = _context5.v;
          if (!(res.data.code === 200)) {
            _context5.n = 2;
            break;
          }
          return _context5.a(2, res.data.data);
        case 2:
          throw new Error("Failed to get pre-signed URLs");
        case 3:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return _preSignUrl.apply(this, arguments);
}